<template>
    <WebSocketLoadingModal
        :title="__('tools.testing.snapshots.apply.pending_modal.notice')"
        :show-modal="showModal"
        :soft-timeout="softTimeout"
        :status-hint="statusHint"
        :dismiss-note="__('tools.testing.snapshots.status.not_cancellable')"
        @close="closeModal"
    />
</template>

<script setup>
import { __ } from '~@/Composables/translation'
import WebSocketLoadingModal from '~@/Components/Common/Modals/WebSocketLoadingModal'
import { usePage } from '@inertiajs/vue3'
import { onUnmounted } from 'vue'

const DONE_EVENT = '.tenant.snapshot.application_done'
const FAILED_EVENT = '.tenant.snapshot.application_failed'

defineProps({
    showModal: {
        type: Boolean,
        default: false
    },
    softTimeout: {
        type: Number,
        default: null
    },
    // Passed down from Index.vue, which owns the single status poller for the page.
    statusHint: {
        type: String,
        default: null
    }
})

const emit = defineEmits(['close', 'applicationDone', 'applicationFailed'])

const closeModal = () => {
    emit('close')
}

const channel = window.laravelEcho.private(`onecrm.tenant.snapshot.${usePage().props.auth.user.id}`)

const onApplicationDone = ({ snapshot }) => {
    emit('applicationDone', snapshot)
}

const onApplicationFailed = ({ error }) => {
    emit('applicationFailed', error)
}

channel
    .listen(DONE_EVENT, onApplicationDone)
    .listen(FAILED_EVENT, onApplicationFailed)

// This component sits behind a v-if, so without this every apply - and every apply that was refused before it even
// started - would leave another pair of listeners on the channel, and one event would be handled several times.
onUnmounted(() => {
    channel.stopListening(DONE_EVENT, onApplicationDone)
    channel.stopListening(FAILED_EVENT, onApplicationFailed)
})

</script>
